<template>
    <sign-contract-annex-dispute-popup-controller v-slot:default="scadpc">
        <on-off v-slot:default="onoff" v-bind:options="{ id: 'sign-contract-annex-dispute-popup', onEsc: false, onBody: false }">
            <div v-if="onoff.ison" class="atmo-popup-wrapper">
                <div class="atmo-popup-content atmo-save-purchase-popup">
                    <button v-on:click.stop="onoff.off" class="atmo-button--small atmo-close"><i class="atmo-icon-close"></i></button>

                    <header>
                        <h5>Подписать и отправить протокол разногласий</h5>

                        <tab-menu-controller v-slot:default="tmc" v-bind:tabmenuid="'sign-contract-tabmenu'">
                            <ul class="atmo-tabs-menu-universal">
                                <li>
                                    <button v-on:click="tmc.select(1)" v-bind:class="{ 'atmo-active': tmc.isSelected(1) }">Информация о документе</button>
                                </li>
                                <li>
                                    <button v-on:click="tmc.select(2)" v-bind:class="{ 'atmo-active': tmc.isSelected(2) }">XML-представление данных</button>
                                </li>
                            </ul>
                        </tab-menu-controller>
                    </header>

                    <tab-menu-tabs-controller v-slot:default="tmtc" v-bind:tabmenuid="'sign-contract-tabmenu'">
                        <main class="atmo-tabs-container">
                            <TabDisputeInfoPreview.view v-if="tmtc.isSelected(1)" v-bind:controller="scadpc" v-bind:certificate="scadpc.currentParsedCertificate" v-bind:attachment="scadpc.custom.attachment" v-bind:comment="scadpc.custom.comment" />

                            <TabXMLPreview.view v-if="tmtc.isSelected(2)" v-bind:xml="scadpc.xml" v-bind:certificate="scadpc.currentParsedCertificate" />
                        </main>
                    </tab-menu-tabs-controller>

                    <footer>
                        <CertificateInfo.view v-if="scadpc.hasCertificatesLoaded" v-bind:certificate="scadpc.currentParsedCertificate" />

                        <ul class="atmo-buttons">
                            <li><button v-on:click="onoff.off" class="atmo-button-inverse atmo-dimmed">Отмена</button></li>
                            <li v-if="!scadpc.isDataSigned && scadpc.hasCertificatesLoaded && scadpc.currentParsedCertificate">
                                <button v-on:click="scadpc.signData" class="atmo-button">Подписать</button>
                                <div class="atmo-spinner"><img src="@themes/atmo/assets/images/loaders/spinner-sector.svg" alt="" /></div>
                            </li>
                            <li v-if="scadpc.isDataSigned">
                                <button v-on:click="scadpc.signAnnexDispute" class="atmo-button">Отправить</button>&nbsp;
                                <div class="atmo-spinner"><img src="@themes/atmo/assets/images/loaders/spinner-sector.svg" alt="" /></div>
                            </li>
                        </ul>
                    </footer>
                </div>
            </div>
        </on-off>
    </sign-contract-annex-dispute-popup-controller>
</template>

<script>
import OnOff from '@lib/js/src/vue/components/OnOffV6.component.js';
import SignContractAnnexDisputePopupController from '@core/js/viewmodels/purchases/item/view/widgets/contract/annexes/sign/SignContractAnnexDisputePopupController.viewmodel';
import TabMenuController from '@lib/js/src/vue/components/tabmenu/TabMenuController.viewmodel';
import TabMenuTabsController from '@lib/js/src/vue/components/tabmenu/TabMenuTabsController.viewmodel';

import TabDisputeInfoPreview from 'themes/views/overlays/popups/common/partials/TabDisputeInfoPreview.view.vue';
import TabXMLPreview from 'themes/views/overlays/popups/common/partials/TabXMLPreview.view.vue';
import CertificateInfoView from 'themes/views/overlays/popups/common/partials/CertificateInfo.view.vue';

export default {
    components: {
        'on-off': new OnOff(),
        'sign-contract-annex-dispute-popup-controller': SignContractAnnexDisputePopupController,
        'tab-menu-controller': TabMenuController,
        'tab-menu-tabs-controller': TabMenuTabsController,
        'TabDisputeInfoPreview.view': TabDisputeInfoPreview,
        'TabXMLPreview.view': TabXMLPreview,
        'CertificateInfo.view': CertificateInfoView
    }
};
</script>
